module.exports = __webpack_public_path__ + "img/skin-detail-completo-video-poster.7ac8fe7.jpg";